import { createSystem, defaultConfig, defineConfig } from "@chakra-ui/react"
import { fonts } from "./theme/tokens/fonts"
import { colors } from "./theme/tokens/colors"
import { textStyles } from "./theme/text-styles"
import { slotRecipes } from "./theme/slot-recipes"
import { keyframes } from "./theme/tokens/keyframes"
import { globalCss } from "./theme/global-css"
import { recipes } from "./theme/recipes"

const config = defineConfig({
  theme: {
    keyframes,
    tokens: {
      fonts: fonts,
      colors: colors,
    },
    textStyles: textStyles,
    slotRecipes: slotRecipes,
    recipes: recipes,
  },
  globalCss,
})

export const system =  createSystem(defaultConfig, config)